const getChildrenInTree = (subtree, result) => {
  // console.log(`getChildrenInTree(): printing subtree`);
  // console.log(JSON.stringify(subtree ? subtree.toJS() : subtree));
  // console.log(`getChildrenInTree(): printing subtree.children (no toJS)`);
  // console.log(`${subtree.children}`);
  const storeId = subtree.id ? subtree.id : "";
  result[storeId] = subtree.children.map(c => c.id).toArray();
  subtree.children.map(childNode => {
    getChildrenInTree(childNode, result);
  });
};

const getChildrenById = tree => {
  let result = {};
  getChildrenInTree(tree, result);
  return result;
};

export default getChildrenById;
